'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTapeTest;
function createTapeTest(_ref) {
  var actions = _ref.actions;
  var imports = _ref.imports;
  var reducer = _ref.reducer;
  var equalityFunction = _ref.equalityFunction;

  var asserts = actions.map(function (action, index) {
    return 'test(\'' + action.action.type + ' (action index ' + index + ') should correctly update state\', function(assert) {\n  var action = actions[' + index + '];\n  var result = reducer(action.prevState, action.action);\n  assert.ok(equality(result, action.nextState), \'state updated correctly\');\n  assert.end();\n});';
  }).join('\n\n');
  return 'var test = require(\'tape\');\n' + imports + '\n' + reducer + '\nvar equality = ' + equalityFunction + ';\nvar actions = ' + JSON.stringify(actions, null, 2) + ';\n\n' + asserts;
}


/*****************
 ** WEBPACK FOOTER
 ** ./dist/create-test/tape.js
 ** module id = 179
 ** module chunks = 0
 **/